import React from 'react';
import { Form, Input, Checkbox } from 'antd';

const InputGroup = Input.Group;

export default function Footer(props) {
    return (
        <div className="row">

            <div className={"col-md-9"}>

            </div>
            <div className="col-md-3 pt-10">
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Importe Honorario</label>
                        <div>{props.formValues.importe.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Retención IR</label>
                        <div>{props.formValues.retencion.toFixed(2)}</div>
                    </div>
                </div>

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Neto Recibido</label>
                        <div>{props.formValues.total.toFixed(2)}</div>
                    </div>
                </div>

            </div>
        </div>
    );
}